import * as types from './types';
import axios from '../../utils/axios';
import * as END_POINTS from '../../utils/endpoints';

export const getStages = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: types.GET_STAGES_REQUEST,
    });
    const stages = await axios.get(END_POINTS.STAGES, {
      params: {
        model_type: payload || 'school',
      },
    });

    dispatch({
      type: types.GET_STAGES_SUCCESS,
      payload: stages?.data?.data ?? [],
    });
  } catch (error) {
    console.log('=============errror=======================');
    console.log(error.response ?? error.message);
    console.log('====================================');
    dispatch({
      type: types.GET_STAGES_FAIL,
      error: error.response?.data?.message ?? error.message,
    });
  }
};

